import { Flex } from '@billy/design-system'

import { OrganizationFeature } from '@features/settings/enums/organizationFeature'
import { useOrganizationFeature } from '@features/settings/hooks/useOrganizationFeature'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Scope } from '../../../../../../enums/scope'
import { isAuthorized } from '../../../../../../utils/isAuthorized'
import { ChartOfAccountsSection } from './elements/ChartOfAccountsSection'
import { FecImportSection } from './elements/FecImportSection'
import { SalesTaxReturnSection } from './elements/SalesTaxReturnSection'

export const OtherSettings = () => {
  const { organization } = useUserOrganization()
  const { hasFeature } = useOrganizationFeature()

  const isDanishOrganization = organization?.countryId === 'DK'
  const isChartOfAccountsReadAuthorized = isAuthorized(Scope.ChartOfAccountsRead)
  const isFecFileImportEnabled = hasFeature(OrganizationFeature.FecFileImport)

  if (!isDanishOrganization && !isChartOfAccountsReadAuthorized && !isFecFileImportEnabled) {
    return null
  }

  return (
    <Flex flexDirection="column">
      {isDanishOrganization && <SalesTaxReturnSection />}
      {isChartOfAccountsReadAuthorized && <ChartOfAccountsSection />}
      {isFecFileImportEnabled && <FecImportSection />}
    </Flex>
  )
}
